module.exports = __webpack_public_path__ + "static/lukasz_walszewski-8a5db344a1c5bb223068e9ecd96acfda.png";